import React from 'react';
import { useTranslation } from 'react-i18next';
import StatusPill, { StatusVariant } from '../../patterns/StatusPill';

export type ProgramStatus = 'open' | 'locked' | 'deleted';

const VARIANT_BY_STATUS: Record<ProgramStatus, StatusVariant> = {
  'open': 'ok',
  'locked': 'info',
  'deleted': 'danger',
};

export interface ProgramStatusPillProps {
  status: ProgramStatus | string;
}

const ProgramStatusPill: React.FC<ProgramStatusPillProps> = ({ status }) => {
  const { t } = useTranslation();
  const variant = VARIANT_BY_STATUS[status as ProgramStatus] ?? 'info';
  const labelKey = `spray.statusLabels.program.${status}`;
  const label = t(labelKey, { defaultValue: status });
  return <StatusPill variant={variant}>{label}</StatusPill>;
};

export default ProgramStatusPill;
